// useMessageDetailType.jsx
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { SHORT_VIDEO_DURATION_SECONDS } from '../RemoteConfigKeys.js';

import getNetworkingData from '../selector/getNetworkingData.js';
import getMessageData from '../selector/getMessageData.js';
import getAssetData from '../selector/getAssetData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import fetchAssetManifest from '../action/fetchAssetManifest.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import { MediaAssetFormat } from '../resource/getMediaAsset.js';

export function useMessageDetailType() {
  const { messageId } = useParams();
  const dispatch = useDispatch();
  const assetIds =
    useSelector(state => getMessageData(state, messageId, 'assetIds')) || [];
  const hasAssetIds = assetIds.length;
  const firstAssetId = assetIds[0];
  const firstAssetContentType =
    useSelector(state => getAssetData(state, [firstAssetId], 'contentType')) ||
    '';
  const duration = useSelector(state =>
    getAssetData(state, [firstAssetId, 'duration'])
  );
  const shortVideoDuration = useSelector(state =>
    getRemoteConfigData(state, SHORT_VIDEO_DURATION_SECONDS)
  );
  const isAssetManifestFetched = useSelector(state =>
    getNetworkingData(
      state,
      ['fetch', 'manifest', messageId, firstAssetId, MediaAssetFormat.MPD],
      'isFetched'
    )
  );

  const isVideo = firstAssetContentType.startsWith('video/');
  useEffect(() => {
    if (isVideo && !duration) {
      const fetchData = () => {
        if (!hasAssetIds) {
          dispatch(fetchMessageDetail({ messageId }));
        }
        if (hasAssetIds) {
          dispatch(fetchAssetManifest({ messageId, assetId: firstAssetId }));
        }
      };
      fetchData();
    }
  }, [messageId, hasAssetIds, firstAssetId, duration, isVideo, dispatch]);

  if (!isAssetManifestFetched && !duration && isVideo) {
    return 'loading';
  }
  if (isVideo) {
    if (shortVideoDuration && duration <= shortVideoDuration) {
      return 'story';
    } else {
      return 'flix';
    }
  }

  return messageId ? 'post' : '';
}

export default useMessageDetailType;
